import * as React from 'react'

interface IToolTipProps {
  message: string
}

interface IToolTipState {
  show: boolean
}

class ToolTip extends React.Component<IToolTipProps, IToolTipState> {
  constructor(props: IToolTipProps) {
    super(props)

    this.state = {
      show: false
    }
    this.hideToolTip = this.hideToolTip.bind(this)
    this.showToolTip = this.showToolTip.bind(this)
  }

  public render() {
    return (
      <span className='tooltip-container tooltip ml-auto' onMouseLeave={this.hideToolTip}>
        {this.state.show && (
          <div className={`tooltip-bubble tooltip-top`}>
            <div className='tooltip-message'>{this.props.message}</div>
          </div>
        )}
        <span onMouseOver={this.showToolTip}>{this.props.children}</span>
      </span>
    )
  }

  private hideToolTip() {
    this.setState({ show: false })
  }
  private showToolTip() {
    this.setState({ show: true })
  }
}

export default ToolTip



// WEBPACK FOOTER //
// ./src/components/ui/ToolTip.tsx